const acceptedImages = 'image/*'

export default acceptedImages
